module.exports = ".table-wrapper {\n  overflow-x: auto;\n  max-height: 450px;\n  width: 100%; }\n\n.strong-label {\n  color: black; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/movimientos-obra/modal-ingreso-interno/modal-ingreso-interno.component.scss
// module id = ./src/app/components/movimientos-obra/modal-ingreso-interno/modal-ingreso-interno.component.scss
// module chunks = main